import { getTargetCount } from "../../../utils/archeryConfig.js";

const TargetsTable = ({ event, date, time, data }) => {
  const targetCount = getTargetCount(date, event);

  // data에서 조 정보 추출
  const groups = data || [];
  // 시간 포맷 변환 함수

  const formatTime = (time, event) => {
    // "오전 09:00" 또는 "오후 02:00" 형식에서 시간과 분 추출
    const timeMatch = time.match(/(\d+):(\d+)/);
    if (!timeMatch) return time;

    const hour = parseInt(timeMatch[1]);
    const min = parseInt(timeMatch[2]);
    const isPM = time.includes("오후");
    const actualHour = isPM && hour !== 12 ? hour + 12 : hour;

    // 145m인 경우
    if (event === "145") {
      return actualHour < 13 ? "오전 09:00" : "오후 12:00";
    }

    // 90m, 70m, 30m인 경우
    if (["90", "70", "30"].includes(event)) {
      if (actualHour < 12) {
        return "오전 09:00";
      } else if (actualHour < 14 || (actualHour === 14 && min < 50)) {
        return "오후 12:10";
      } else {
        return "오후 02:55";
      }
    }

    // 그 외의 경우 원본 시간 반환
    return time;
  };

  // 선수 데이터를 조와 과녁별로 매핑
  const getPlayersForTarget = (targetNum) => {
    const allPlayers = [];

    groups.forEach((groupData) => {
      const groupPlayers = groupData?.players || [];
      const targetPlayers = groupPlayers.filter(
        (p) => p.target === String(targetNum)
      );

      targetPlayers.forEach((player, index) => {
        allPlayers.push({
          ...player,
          genderLabel: player.genderLabel,
          groupName: groupData.group, // 그룹 정보
          positionInGroup: player.position, // 그룹 내 순서 (1부터 시작)
        });
      });
    });

    return allPlayers;
  };

  // 단일 과녁 테이블 생성 함수
  const createTargetTable = (targetNum, players) => {
    return (
      <div key={targetNum} className="table-box box-2">
        <div className="table-title">
          {/* group {group1}/{group2} Target{targetNum}  */}{date} {time}
        </div>
        <div className="table-wrap">
          <div className="table-shadow">
            <table>
              <colgroup>
                <col width="8%" />
              </colgroup>
              <thead>
                <tr>
                  {/* <th rowSpan="2">Num</th> */}
                  <th>Country</th>
                  <th>PlayerName</th>
                  <th>Gender</th>
                  {/* <th>Group</th>
                  <th>Target</th>
                  <th>Shooting<br/>zone NO.</th> */}
                </tr>
              </thead>
              <tbody>
                {players.map((player, index) => (
                  <tr key={`${targetNum}-${index}`}>
                    {/* <td>{index + 1}</td> */}
                    <td>{player.country}</td>
                    <td>{player.name}</td>
                    <td>{player.genderLabel}</td>
                    {/* <td>{player.groupName}</td>
                    <td style={{ color: "red" }}>{player.target}</td>
                    <td>{player.positionInGroup}</td> */}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="table-gradient"></div>
        </div>
      </div>
    );
  };

  // 모든 과녁 테이블 생성
  const allTables = [];
  for (let targetNum = 1; targetNum <= targetCount; targetNum++) {
    const players = getPlayersForTarget(targetNum);
    if (players.length != 0)
      allTables.push(createTargetTable(targetNum, players));
  }

  return allTables.length != 0 ? (
    <div>
      <div className="table-flex">{allTables}</div>
      <br />
      <br />
      <br />
    </div>
  ) : (
    <></>
  );
};
export default TargetsTable;
